// extracted by mini-css-extract-plugin
module.exports = {"RoundTab":"RoundTab_RoundTab__3oOB2","RoundTab-active":"RoundTab_RoundTab-active__1BZHl"};